import { createAction } from '@reduxjs/toolkit';
import { tagTypes } from 'lib/src/shared/enums/tagTypes';
import { ChallengeTag } from 'lib/src/types/shared/ChallengeTag';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

export const postCreateTagRequest = createAction('postCreateTagRequest');
export const postCreateTagSuccess = createAction<ChallengeTag>('postCreateTagSuccess');
export const postCreateTagFailure = createAction('postCreateTagFailure');

export const postCreateTag = (postBody: PostBody) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(postCreateTagRequest());
    try {
        let route = 'admin/challengeTags';
        if (postBody.type === tagTypes.business) route += '/business';
        const { data } = await api.post<PostBody, ChallengeTag>(route, postBody);

        dispatch(postCreateTagSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, postCreateTagFailure, e);
    }
};

type PostBody = {
    name: string;
    isPublic: boolean;
    type: tagTypes;
};
